import type { ErrorResponseBody } from '@repo/errors';

/**
 * Extracts a user-facing error message from an API error response. The wire
 * shape is the `@repo/errors` standard envelope (`ErrorResponseBody`). Falls
 * back to a default message if the response doesn't match that shape.
 */
export function extractErrorMessage(errorData: unknown, fallback: string): string {
  if (
    typeof errorData === 'object' &&
    errorData !== null &&
    'error' in errorData &&
    typeof (errorData as ErrorResponseBody).error?.message === 'string'
  ) {
    return (errorData as ErrorResponseBody).error.message;
  }
  return fallback;
}
